import { AdminLayout } from "@/views/layouts/AppLayout";
import LianYunUserDashboard from "@/views/pages/dashboard/components/lianYunUser";
import { FunctionalOperationAnalysisPage } from "@/views/pages/dashboard/functionalOperationAnalysis/FunctionalOperationAnalysisPage";
import { GoodsOperationAnalysisPage } from "@/views/pages/dashboard/lianyunOperationAnalysis/goodsOperationAnalysis/GoodsOperationAnalysisPage";
import { ConsignmentGoodsAnalysisDetailPage } from "@/views/pages/dashboard/lianyunOperationAnalysis/consignmentGoodsAnalysisDetail/ConsignmentGoodsAnalysisDetailPage";
import { ShareStatisticalPage } from "@/views/pages/dashboard/shareStatistical/ShareStatisticalPage";
import { ShareStatisticalDetailPage } from "@/views/pages/dashboard/shareStatistical/ShareStatisticalDetailPage";
import { ShipAnalysisPage } from "@/views/pages/dashboard/shipAnalysis/ShipAnalysisPage";
import { ShipNeedAnalysisPage } from "@/views/pages/dashboard/shipNeedAnalysis/ShipNeedAnalysisPage";
import type { AdminRouteObject } from "../index";

/** 运营分析路由，沿用 Vue dashboard 页面路径、标题和权限码。 */
export const dashboardRoutes: AdminRouteObject = {
    path: "/dashboard",
    element: <AdminLayout />,
    // 旧 Vue 一级菜单名称为“运营分析”，首页仅作为该模块下的用户看板。
    handle: { title: "运营分析" },
    children: [
        {
            // 默认入口与 Vue /dashboard/index 共用用户看板权限，避免直接访问 /dashboard 绕过授权。
            index: true,
            element: <LianYunUserDashboard />,
            handle: {
                title: "用户看板",
                permissions: ["ROLE_DEAL_BI", "ROLE_USER_BI", "ROLE_SHIP_BI"]
            }
        },
        {
            // dashboard/index 是旧 Vue 用户看板入口，保留三类看板的查看权限集合。
            path: "index",
            element: <LianYunUserDashboard />,
            handle: {
                title: "用户看板",
                permissions: ["ROLE_DEAL_BI", "ROLE_USER_BI", "ROLE_SHIP_BI"]
            }
        },
        {
            path: "functionalOperationAnalysis",
            element: <FunctionalOperationAnalysisPage />,
            handle: { title: "用户行为", permissions: ["ROLE_SAND_FUNCTION_BI_R"] }
        },
        {
            path: "goodsOperationAnalysis",
            element: <GoodsOperationAnalysisPage />,
            handle: { title: "商品运营", permissions: ["ROLE_SAND_PRODUCT_BI_R"] }
        },
        {
            path: "consignmentGoodsAnalysisDetail",
            element: <ConsignmentGoodsAnalysisDetailPage />,
            handle: { title: "商品运营详情", permissions: ["ROLE_SAND_PRODUCT_BI_R"] }
        },
        {
            path: "shareStatistical",
            element: <ShareStatisticalPage />,
            handle: { title: "分享统计", permissions: ["ROLE_SHARE_STATISTICS_R"] }
        },
        {
            path: "shareStatistical/detail/:id",
            element: <ShareStatisticalDetailPage />,
            handle: { title: "分享统计详情", permissions: ["ROLE_SHARE_STATISTICS_R"] }
        },
        {
            path: "shipAnalysis",
            element: <ShipAnalysisPage />,
            handle: { title: "匹配船舶分析", permissions: ["ROLE_MATCH_SHIP_R"] }
        },
        {
            path: "shipNeedAnalysis",
            element: <ShipNeedAnalysisPage />,
            handle: { title: "船运需求转化分析", permissions: ["ROLE_DEMAND_CONVERSION_R"] }
        }
    ]
};

export default dashboardRoutes;
